import {AcademicSectionApi} from '../_api/ilerna-StudentAccount/src';
import {lazySingleton} from "../_common/common";


export class AcademicSectionService{
    
    constructor() {
        this._api = new AcademicSectionApi();
    }

    async getAllAcademicSections() {
        const academicSections = await this._api.getAllAcademicSections()
        return academicSections;
    }

    async getAcademicSection(id) {
        const academicSection = await this._api.getAllAcademicSectionsById(id)
        return academicSection;
    }    
}

export const svcAcademicSection = lazySingleton(()=> new AcademicSectionService()); // singleton